import React, {ReactElement} from 'react';
import {useFormikContext} from 'formik';
import ToolbarNotificationDisplay from './toolbar-notification-display';
import {noop} from 'lodash';

const ToolbarNotificationPreviewForForm = (): ReactElement => {
  const {
    values: {htmlContent},
  } = useFormikContext<{htmlContent: string}>();

  return <ToolbarNotificationDisplay htmlContent={htmlContent} onDismiss={noop} />;
};

export default ToolbarNotificationPreviewForForm;
